import React, { useState } from "react";
import { Button, TextField, Autocomplete, Box } from "@mui/material";
import { UseMyPC } from "../../hooks/UseMyPC";
import { UseRelatedArticle } from "./UseRelatedArticle";
import { useNavigate, useLocation } from "react-router-dom";
import Detail from "../../main/detail/Detail";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import SearchRArticle from "./SearchRArticle";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function AddRelatedArticle(props) {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const [progress, setProgress] = useRecoilState(rsProgress);
  const navigate = useNavigate();
  const location = useLocation();
  const { addRelated } = UseRelatedArticle();
  const [msGotoLast, setMsGotoLast] = useRecoilState(rsGotoLast);
  const { isSmall } = useBreakpoints();

  const [state, setState] = React.useState({
    masterArticleId: "",
    slaveArticleId: "",
  });

  return (
    <Detail
      breadChilds={{
        title: "مدیریت محتوا",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/relatedarticle" },
          {
            name: "افزودن مقاله اسلیو",
            url: "/relatedarticle/addRelatedArticle",
          },
        ],
      }}
    >
      <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
        <Box gridColumn={isSmall ? "span 12" : "span 6"}>
          <SearchRArticle setState={setState} state={state} master />
        </Box>
        {!isSmall && <Box gridColumn="span 6"></Box>}
        <Box gridColumn={isSmall ? "span 12" : "span 6"}>
          <SearchRArticle setState={setState} state={state} slave />
        </Box>
        {!isSmall && <Box gridColumn="span 6"></Box>}
        <Box
          sx={{ display: "flex", justifyContent: "flex-end" }}
          gridColumn={isSmall ? "span 12" : "span 6"}
        >
          <Button
            sx={{ mr: 2, width: "80px" }}
            variant="contained"
            color="secondary"
            onClick={() => {
              setProgress(true);
              addRelated(state, () => {
                setMsGotoLast(true);
                navigate("/relatedarticle", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              });
            }}
          >
            ایجاد
          </Button>
          <Button
            sx={{ width: "80px" }}
            variant="outlined"
            color="secondary"
            onClick={() => {
              navigate("/relatedarticle", {
                state: { ...location.state, isBack: true },
                replace: true,
              });
            }}
          >
            بازگشت
          </Button>
        </Box>
      </Box>
    </Detail>
  );
}
